import RecaptchaWrapper from "./recaptcha-wrapper";
import ReCAPTCHA from "./recaptcha";
export default RecaptchaWrapper;
export { ReCAPTCHA };


// WEBPACK FOOTER //
// ./~/react-google-recaptcha/lib/esm/index.js